import AddingMicroservice from './AddingMicroservice';
import MicroservicesList from './MicroservicesList';
import BitdefenderLogo from '../../../base_components/BitdefenderLogo';

import styles from '../../../styles/base_components/Page.module.scss';

function Microservices(props) {
  return (
    <div className={styles.page}>
      <AddingMicroservice className={styles.group}/>
      <MicroservicesList className={styles.group}/>

      <BitdefenderLogo/>
    </div>
  );
}

export default Microservices;